import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Importer } from 'src/app/core/models/importer';
import { ImporterService } from 'src/app/core/services/general/importer.service';
import { CreateImporterModalComponent } from '../create-importer-modal/create-importer-modal.component';

@Component({
  selector: 'app-importer-input',
  templateUrl: './importer-input.component.html',
  styleUrls: ['./importer-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ImporterInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ImporterInputComponent,
    },
  ],
})
export class ImporterInputComponent {
  @Input()
  title = "Select Importer...";

  @Input()
  isDisabled = false;

  /**
   * When true the control binds the importer's NAME instead of its uuid — used where the record
   * stores a denormalised importer name (e.g. a check-in's importer_name) rather than an FK.
   * Defaults false so every existing uuid-bound usage is byte-unchanged.
   */
  @Input()
  bindName = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public importersList: Array<CustomSelectOption> = [];

  constructor(
    private importerService: ImporterService,
    private modalService: NgbOffcanvas,
  ) {
    this.importerService
      .all()
      .subscribe((res: Array<Importer>) => {
        this.importersList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: this.bindName ? `${el.name}` : el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined && this.value != null && this.value !== '') {
      let match = this.importersList.filter((el) => el.value == val)[0];
      if (!match && this.bindName) {
        // A saved name that isn't (yet) in the loaded list — e.g. a legacy free-typed
        // importer_name. Keep it as an ad-hoc option so it displays and is NOT wiped on re-save.
        match = { name: `${val}`, value: `${val}` };
        this.importersList = [match, ...this.importersList];
      }
      this.localValue = match;
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }


  createNewImporter() {
    const modalRef = this.modalService.open(CreateImporterModalComponent, {
      position: 'end',
      panelClass: "w-75"
    });
    modalRef.result.then(() => {
      let createdImporterString = localStorage.getItem('created-importer');
      if (createdImporterString) {
        localStorage.removeItem('created-importer');
        let createdImporter = new Importer(JSON.parse(createdImporterString)!);
        const newValue = this.bindName ? `${createdImporter.name}` : createdImporter.uuid;
        this.importersList.push({
          name: `${createdImporter.name}`,
          value: newValue,
        });
        this.onValueChange(this.importersList.filter((el) => el.value == newValue)[0])
      }
    });
  }
}
